import { UploadFileInfo } from '@progress/kendo-react-upload';
import { BreadcrumbDataModel, DataModel, GridViewBtnGroup, SortingBtnGroup } from '../interfaces/FileManagerModels';
import {
  filePdfIcon,
  filePptIcon,
  fileDataIcon,
  fileImageIcon,
  fileTxtIcon,
  fileAudioIcon,
  folderIcon,
  fileIcon
} from '@progress/kendo-svg-icons';
import {useInternationalization} from "@progress/kendo-react-intl";


export const convertExtensionToIcon = (item: string | null | undefined) => {
  if (!item) { return null; }
  const splitImage = item.split('.')
  const extension: string | null = splitImage.length > 1 ? splitImage[splitImage.length - 1] : null;

  // console.log(extension)
  switch (extension ? extension.toLowerCase() : null) {
    case 'pdf':
      return {
        svgIcon: filePdfIcon,
        type: 'Data'
      };
    case 'zip':
      return {
        svgIcon: filePdfIcon,
        type: 'Data'
      };
    case 'ppt': case 'pptx':
      return {
        svgIcon: filePptIcon,
        type: 'Data'
      };
    case 'xlsx': case 'xls':
      return {
        svgIcon: fileDataIcon,
        type: 'Data'
      };
    case 'jpg': case 'jpeg': case 'png':
      return {
        svgIcon: fileImageIcon,
        type: 'Image'
      };
    case 'txt': case 'doc': case 'docx':
      return {
        svgIcon: fileTxtIcon,
        type: 'Text'
      };
    case 'mp3': case 'mp4': case 'mp':
      return {
        svgIcon: fileAudioIcon,
        type: 'Text'
      };
    case null:
      return {
        svgIcon: folderIcon,
        type: 'Folder'
      };
    default:
      return {
        svgIcon: folderIcon,
        type: 'Folder'
      };
  };
};

export const getName = (path: string | undefined) => {
  if (!path) { return path; }
  return path.split('/').pop();
}

export const getFolderPath = (path: string | undefined) => {
  if (!path) { return path; }
  const pathArr = path.split('/');
  pathArr.pop();
  return pathArr.join('/');
}

export const convertDateFormat = (date: Date | null, intl) => {
  return date ? intl.formatDate(date, 'd.MM.y  h:mm:ss aa  EEEE') : date;
};

const mapData = (data, intl) => {
  if (!data) { return []; }

  return data.map(item => {
    const name = getName(item.path);
    return {
      path: item.path,
      id: item.id,
      parentid: item.parentid,
      isfolder: item.isfolder,
      rootname: item.rootname,
      name: item.name,
      dateCreated: convertDateFormat(item.dateCreated || null, intl),
      dateModified: convertDateFormat(item.dateModified || null, intl),
      size: item.size,
      icon: convertExtensionToIcon(name),
      items: item.items && item.items.length ? mapData(item.items, intl) : [],
      Thumbnail: item.Thumbnail,
      issaveasbuilt: item.issaveasbuilt,
      issystem: item.isSystem,
      sharedid: item.sharedid,
      allowfolder: item?.allowfolder,
      allowdelete: item?.allowdelete,
      allowsave: item?.allowsave,
      allowcopy: item?.allowcopy,
      allowmove: item?.allowmove,
      allowpaste: item?.allowpaste,
      allowrename: item?.allowrename,
      allowdownload: item?.allowdownload,
      allowupload: item?.allowupload,
    }
  });
};

export const formatData = (data: DataModel[], intl) => {
  return mapData(data, intl);
};

export const getFolderTree = (data: DataModel[], selectedItem: DataModel | null = null) => {
  // console.log('getFolderTree')
  if (!data) { return data; }
  const newItems: DataModel[] = [];

  for (let index = 0; index < data.length; index++) {
    const currentItem = { ...data[index] };
    if (currentItem.path && currentItem.isfolder) {
      if (currentItem.items && currentItem.items.length) {
        currentItem.items = getFolderTree(currentItem.items, selectedItem);
      }
      newItems.push({
        ...currentItem,
        selected: selectedItem ? selectedItem.id === currentItem.id : false,
      });
    }
  }
  return newItems;
};

export const searchTreeItemPath = (data, selectedItem: DataModel | null) => {
  if (!selectedItem) { return data; }

  for (let index = 0; index < data.length; index++) {
    const currentItem = data[index];
    if (currentItem.path === selectedItem.path) {
      return currentItem;
    }
    if (currentItem.items && currentItem.items.length) {
      const foundItem = searchTreeItemPath(currentItem.items, selectedItem);
      if (foundItem) {
        return foundItem;
      }
    }
  }
  return false;
};
export const searchTreeItem = (data, selectedItem: DataModel | null) => {
  if (!selectedItem) { return data; }

  for (let index = 0; index < data.length; index++) {
    const currentItem = data[index];
    if (currentItem?.id === selectedItem?.id) {
      return currentItem;
    }
    if (currentItem.items && currentItem.items.length) {
      const foundItem = searchTreeItem(currentItem.items, selectedItem);
      if (foundItem) {
        return foundItem;
      }
    }
  }
  return false;
};

export const searchTreeItemByParentId = (data, parentId) => {
  for (let index = 0; index < data.length; index++) {
    const currentItem = data[index];
    if (currentItem?.id === parentId) {
      return currentItem;
    }
    if (currentItem.items && currentItem.items.length) {
      const foundItem = searchTreeItemByParentId(currentItem.items, parentId);
      if (foundItem) {
        return foundItem;
      }
    }
  }
  return false;
};

export const searchTreeItemForValue = (newItems, data, value) => {
  // const newItems: DataModel[] = [];

  // debugger
  for (let index = 0; index < data?.length; index++) {
    const currentItem = { ...data[index] };
    if (currentItem.items && currentItem.items.length) {
      searchTreeItemForValue(newItems, currentItem.items, value);
    }

    if (currentItem.name.toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) >= 0) {
      if (!currentItem?.isfolder) {
        //   currentItem.expanded = true
        // }
        // else {
        newItems.push(currentItem);
      }
    }
  }
  // debugger
  // return newItems;
};

export const searchFoldersandFilesValue = (data, value) => {
  const newItems: DataModel[] = [];

  debugger
  for (let index = 0; index < data.length; index++) {
    const currentItem = { ...data[index] };
    if (currentItem.items && currentItem.items.length) {
      currentItem.items = searchFoldersandFilesValue(currentItem.items, value);
    }

    if (currentItem.name.toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) >= 0 || currentItem?.items?.length > 0) {
      if (currentItem?.isfolder) {
        currentItem.expanded = true
      }
      newItems.push(currentItem);
    }
  }
  return newItems;
};

export const addDataItemWithPath = (data: DataModel[], selectedItem: DataModel | null = null, files: any, path, intl) => {
  if (!selectedItem) {
    files.forEach(file => {
      data.push({
        path: `${path}/${file.name}`,
        id: file.id,
        parentid: selectedItem.id,
        name: file.name,
        isfolder: file.isfolder,
        dateCreated: convertDateFormat(new Date(), intl),
        dateModified: convertDateFormat(new Date(), intl),
        size: file?.size,
        icon: convertExtensionToIcon(file.name),
        Thumbnail: file?.Thumbnail,
        issaveasbuilt: file?.issaveasbuilt,
        issystem: file?.issaveasbuilt,
        sharedid: file?.sharedid,
        allowfolder: file?.allowfolder,
        allowdelete: file?.allowdelete,
        allowsave: file?.allowsave,
        allowcopy: file?.allowcopy,
        allowmove: file?.allowmove,
        allowpaste: file?.allowpaste,
        allowrename: file?.allowrename,
        allowdownload: file?.allowdownload,
        allowupload: file?.allowupload,
      });
    });

    return data;
  }

  if (!data) { return data; }

  return data.map((item) => {
    const currentItem = { ...item };

    if (currentItem.id === selectedItem.id) {
      files.forEach(file => {

        if (!currentItem.items) {
          currentItem.items = [];
        }

        currentItem.items.push({
          path: `${path}/${file.name}`,
          id: file.id,
          name: file?.name,
          icon: convertExtensionToIcon(file.name),
          parentid: selectedItem?.id,
          dateCreated: convertDateFormat(new Date(), intl),
          dateModified: convertDateFormat(new Date(), intl),
          size: file?.size,
          isfolder: file?.isfolder,
          Thumbnail: file?.Thumbnail,
          issaveasbuilt: file?.issaveasbuilt,
          issystem: file?.issaveasbuilt,
          sharedid: file?.sharedid,
          allowfolder: file.allowfolder,
          allowdelete: file.allowdelete,
          allowsave: file.allowsave,
          allowcopy: file.allowcopy,
          allowmove: file.allowmove,
          allowpaste: file.allowpaste,
          allowrename: file.allowrename,
          allowdownload: file.allowdownload,
          allowupload: file.allowupload,
        });

      });

    } else if (currentItem.items && currentItem.items.length) {
      currentItem.items = addDataItemWithPath(currentItem.items, selectedItem, files, path, intl);
    }

    return currentItem;
  });
};
export const addDataItem = (data: DataModel[], selectedItem: DataModel | null = null, files: any, intl) => {
  if (!selectedItem) {
    files.forEach(file => {
      data.push({
        path: `Home/${file.name}`,
        dateCreated: convertDateFormat(new Date(), intl),
        dateModified: convertDateFormat(new Date(), intl),
        size: file.size,
        id: file.id,
        icon: convertExtensionToIcon(file.extension),
        issaveasbuilt: file.issaveasbuilt,
        issystem: file.issaveasbuilt,
        sharedid: file.sharedid,
        allowfolder: file.allowfolder,
        allowdelete: file.allowdelete,
        allowsave: file.allowsave,
        allowcopy: file.allowcopy,
        allowmove: file.allowmove,
        allowpaste: file.allowpaste,
        allowrename: file.allowrename,
        allowdownload: file.allowdownload,
        allowupload: file.allowupload,
      });
    });

    return data;
  }

  if (!data) { return data; }

  return data.map((item) => {
    const currentItem = { ...item };

    if (currentItem.id === selectedItem.id) {
      files.forEach(file => {

        if (!currentItem.items) {
          currentItem.items = [];
        }

        currentItem.items.push({
          path: `${currentItem.path}/${file.name}`,
          dateCreated: convertDateFormat(new Date(), intl),
          dateModified: convertDateFormat(new Date(), intl),
          size: file.size,
          id:  file.id,
          icon: convertExtensionToIcon(file.extension),
          issaveasbuilt: file.issaveasbuilt,
          issystem: file.issaveasbuilt,
          sharedid: file.sharedid,
          allowfolder: file.allowfolder,
          allowdelete: file.allowdelete,
          allowsave: file.allowsave,
          allowcopy: file.allowcopy,
          allowmove: file.allowmove,
          allowpaste: file.allowpaste,
          allowrename: file.allowrename,
          allowdownload: file.allowdownload,
          allowupload: file.allowupload,
        });

      });

    } else if (currentItem.items && currentItem.items.length) {
      currentItem.items = addDataItem(currentItem.items, selectedItem, files, intl);
    }

    return currentItem;
  });
};

export const addFolder = (id: string, data: DataModel[], selectedItem: DataModel | null, folderName: string, intl) => {
  if (!selectedItem) {
    data.push({
      path: `Home/${folderName}`,
      dateCreated: convertDateFormat(new Date(), intl),
      dateModified: convertDateFormat(new Date(), intl),
      size: 124,
      id: id,
      icon: convertExtensionToIcon(folderName),
      issaveasbuilt: selectedItem.issaveasbuilt,
      issystem: selectedItem.issaveasbuilt,
      sharedid: selectedItem.sharedid,
      allowfolder: selectedItem.allowfolder,
      allowdelete: selectedItem.allowdelete,
      allowsave: selectedItem.allowsave,
      allowcopy: selectedItem.allowcopy,
      allowmove: selectedItem.allowmove,
      allowpaste: selectedItem.allowpaste,
      allowrename: selectedItem.allowrename,
      allowdownload: selectedItem.allowdownload,
      allowupload: selectedItem.allowupload,
    });

    return data.map(item => item);
  }

  if (!data) { return data; }

  return data.map(item => {
    const currentItem = { ...item };

    if (currentItem.id === selectedItem?.id) {
      console.log(currentItem.items)
      const folderItem = {
        name: folderName,
        parentid: currentItem.id,
        id: id,
        isfolder: true,
        expanded: true,
        path: `${currentItem.path}/${folderName}`,
        dateCreated: convertDateFormat(new Date(), intl),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        items: [],
        icon: convertExtensionToIcon(folderName),
        rootname: currentItem.rootname,
      }

      if (currentItem.items == undefined) {
        currentItem.items = [folderItem];
      }
      else {
        currentItem.items.push(folderItem);
      }
    } else if (currentItem.items && currentItem.items.length) {
      addFolder(id, currentItem.items, selectedItem, folderName, intl);
    }

    return currentItem;
  });
};

export const toggleViewBtnGroup = (btnGroupState: GridViewBtnGroup, view: string) => {
  if (!btnGroupState.listView && view !== 'grid') {
    return { gridView: false, listView: true };
  }
  if (!btnGroupState.gridView && view !== 'list') {
    return { gridView: true, listView: false };
  }
  return btnGroupState;
};

export const toggleSortBtnGroup = (btnGroupState: SortingBtnGroup, curState: string) => {
  if (!btnGroupState.sortDesc && curState !== 'asc') {
    return { sortAsc: false, sortDesc: true };
  }
  if (!btnGroupState.sortAsc && curState !== 'desc') {
    return { sortAsc: true, sortDesc: false };
  }
  return btnGroupState;
};

export const formatBytes = (bytes: number, decimals: number = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k: number = 1024;
  const dm: number = decimals < 0 ? 0 : decimals;
  const sizes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i: number = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const editDataItem = (data, selectedItem: DataModel, newPath: string) => {
  if (!data) { return data; }
  const newItems: DataModel[] = [];

  for (let index = 0; index < data.length; index++) {
    const currentItem = { ...data[index] };
    if (currentItem.id === selectedItem.id) {
      currentItem.path = newPath;
      currentItem.dateModified = new Date();
    }

    if (currentItem.items) {
      currentItem.items = editDataItem(currentItem.items, selectedItem, newPath);
    }
    newItems.push(currentItem);
  }
  return newItems;
};

export const editDataItemName = (data, selectedItem: DataModel, newPath: string, newName: string, intl) => {
  if (!data) { return data; }
  const newItems: DataModel[] = [];

  for (let index = 0; index < data.length; index++) {
    const currentItem = { ...data[index] };
    if (currentItem.id === selectedItem.id) {
      currentItem.path = newPath;
      currentItem.name = newName;
      currentItem.dateModified = convertDateFormat(new Date(), intl);
    }

    if (currentItem.items) {
      currentItem.items = editDataItemName(currentItem.items, selectedItem, newPath, newName, intl);
    }
    newItems.push(currentItem);
  }
  return newItems;
};

export const removeDataItem = (data, selectedItem: DataModel) => {
  if (!data) { return data; }
  const newItems: DataModel[] = [];

  for (let index = 0; index < data.length; index++) {
    const currentItem = { ...data[index] };
    if (currentItem.id !== selectedItem.id) {
      if (currentItem.items && currentItem.items.length) {
        currentItem.items = removeDataItem(currentItem.items, selectedItem);
      }

      newItems.push(currentItem);
    }
  }
  return newItems;
};

export const convertToBreadcrumbData = (selectedItem: DataModel | null) => {
  let path: BreadcrumbDataModel[] = [];

  if (!selectedItem) {
    return [{
      id: 'Home',
      name: 'Home',
    }];
  }

  if (selectedItem.path) {
    const items = selectedItem.path.split('/');
    let curItemPath: string[] = [];

    for (let i = 0; i < items.length; i++) {
      curItemPath.push(items[i])

      if (items[i] === 'Home') {
        path.push({
          id: 'Home',
          name: items[i],
        });
      } else {
        path.push({
          id: curItemPath.join('/'),
          name: items[i],
        });
      }
    }
  }
  return path;
};
